<template>
    <div class="flex flex-row flex-nowrap">
        <slot />
    </div>
</template>
